<div
  *finLet="{
    enabledStatus: twoFactorAuthService.enabledStatus$ | async,
    lastUpdateStatus: (twoFactorAuthService.lastUpdateStatus$ | async)?.status,
  } as twoFactorAuth"
  class="avios-linking-and-exchange flex flex--column ps-medium border rounded-large"
>
  <div class="flex">
    <div class="avios-linking-and-exchange-info-left flex--basis-full ms-medium-b">
      <cms-rich-text
        *ngIf="transferBetweenAccountsFragment$ | async as article"
        [extraClasses]="article.subjectTaxonomyTags?.join(' ')"
        [content$]="transferBetweenAccountsFragment$"
        [headerLevel]="2"
        [headerStyles]="['font-heading-5', 'ms-medium-b']"
        data-testid="avios-linking-and-exchange-info-left"
      >
      </cms-rich-text>
    </div>

    <div
      *ngIf="
        (aviosLinkingStatus$ | async) === AviosAccountLinkingStatus.ACTIVE;
        else aviosLinkingAndExchangeInfoRightInactive
      "
      class="avios-linking-and-exchange-info-right-active flex--basis-full ms-medium-b"
      data-testid="avios-linking-and-exchange-info-right-active"
    >
      <hr class="dn-laptop-up ms-medium-b" />

      <h2 class="font-heading-5">{{ 'LOYALTY.aviosLinkingAndExchange.linkedAccount' | finLocalization }}</h2>
      <div
        class="avios-linking-and-exchange-info-right-active-linked-account flex rounded-large nordic-blue-25-bg ms-medium-t ps-medium-x ps-medium-y"
      >
        <div class="flex flex-1 flex--middle">
          <div class="flex--nogrow">
            <fcom-icon class="baec-emblem" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.BAEC_EMBLEM"></fcom-icon>
          </div>
          <span class="flex-1 font-body-1 ms-xsmall-l ms-small-r">{{ AviosPartner.BAEC }}</span>
        </div>

        <hr class="dn-laptop-up fill ms-medium-y" />

        <fcom-button
          [text]="'LOYALTY.aviosLinkingAndExchange.unlinkAccount' | finLocalization"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          [disabled]="!twoFactorAuth.enabledStatus.isEnabled"
          [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          (clickBtn)="onUnlinkAccountClickBtn()"
          class="flex--self-center"
          data-testid="avios-linking-and-exchange-info-right-active-unlink-account-button"
        ></fcom-button>
      </div>

      <fcom-notification
        *ngIf="!twoFactorAuth.enabledStatus.isEnabled"
        [theme]="NotificationTheme.ALERT"
        [buttonStyle]="NotificationButtonStyle.LINK"
        [compact]="true"
        [linkText]="'LOYALTY.aviosLinkingAndExchange.enable2faNotification.enableNow' | finLocalization"
        (linkClick)="onEnable2FAAuthenticationClickBtn(false)"
        class="ms-medium-t"
      >
        {{ 'LOYALTY.aviosLinkingAndExchange.enable2faNotification.text' | finLocalization }}
      </fcom-notification>
    </div>

    <ng-template #aviosLinkingAndExchangeInfoRightInactive>
      <div
        class="avios-linking-and-exchange-info-right-inactive flex--basis-full flex flex--center flex--wrap"
        data-testid="avios-linking-and-exchange-info-right-inactive"
      >
        <div class="ms-medium-y">
          <fcom-icon
            class="finnair-logo-plus"
            [category]="IconLibrary.CUSTOM"
            [name]="CustomIcon.FINNAIR_LOGO_PLUS"
          ></fcom-icon>
        </div>
        <div class="flex--nogrow ms-large-x ms-medium-y">
          <fcom-icon class="icon-small" [name]="SvgLibraryIcon.SWITCH_FLIGHTS"></fcom-icon>
        </div>
        <div class="flex--nogrow ms-medium-y">
          <fcom-icon class="baec-logo" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.BAEC_LOGO"></fcom-icon>
        </div>
      </div>
    </ng-template>
  </div>

  <div
    *ngIf="(aviosLinkingStatus$ | async) === AviosAccountLinkingStatus.ACTIVE; else stepsToLinkAccount"
    class="flex"
    data-testid="avios-linking-and-exchange-content-active"
  >
    <fcom-button
      [text]="'LOYALTY.aviosLinkingAndExchange.transferAvios' | finLocalization"
      [disabled]="!twoFactorAuth.enabledStatus.isEnabled"
      [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      (clickBtn)="onTransferAviosClickBtn()"
      data-testid="avios-linking-and-exchange-content-active-transfer-avios-button"
    ></fcom-button>
  </div>

  <ng-template #stepsToLinkAccount>
    <div data-testid="avios-linking-and-exchange-content-inactive">
      <hr class="ms-medium-b" />

      <ng-container
        *finLet="{
          activeStep: stepperActiveStep$ | async,
          activeStepIndex: stepperActiveStepIndex$ | async,
          steps: stepperSteps$ | async,
        } as stepper"
      >
        <fcom-stepper
          [showLabels]="false"
          [steps]="stepper.steps"
          [activeStep]="stepper.activeStepIndex"
          (clicked)="onStepperClicked($event)"
          class="block ms-medium-b"
        ></fcom-stepper>

        <ng-container [ngSwitch]="stepper.activeStep">
          <ng-container *ngSwitchCase="LinkAccountsFlowStep.ENABLE_TWO_FACTOR_AUTH">
            <h3 class="font-heading-5">
              {{ stepper.steps[stepper.activeStepIndex].title | finLocalization }}
            </h3>
            <div
              class="ms-medium-y"
              data-testid="avios-linking-and-exchange-content-inactive-enable-2fa-auth-description"
            >
              <div class="flex" *ngIf="twoFactorAuth.enabledStatus.isEnabled; else enable2Fa">
                <div class="flex--nogrow ms-xsmall-r">
                  <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
                </div>

                <div
                  [innerHTML]="
                    'LOYALTY.aviosLinkingAndExchange.enable2faAuthentication.description.enabled'
                      | finLocalization
                      | finSafe: 'html'
                  "
                ></div>
              </div>

              <ng-template #enable2Fa>
                <p>
                  {{ 'LOYALTY.aviosLinkingAndExchange.enable2faAuthentication.description.enable' | finLocalization }}
                </p>
              </ng-template>
            </div>

            <fcom-button
              [text]="
                (twoFactorAuth.enabledStatus.isEnabled
                  ? 'LOYALTY.aviosLinkingAndExchange.enable2faAuthentication.action.continueToStep2'
                  : 'LOYALTY.aviosLinkingAndExchange.enable2faAuthentication.action.enable'
                ) | finLocalization
              "
              [icon]="
                twoFactorAuth.enabledStatus.isEnabled
                  ? {
                      name: SvgLibraryIcon.ARROW_RIGHT,
                      position: IconPosition.RIGHT,
                    }
                  : undefined
              "
              [loading]="twoFactorAuth.lastUpdateStatus === TwoFactorAuthStatus.LOADING"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="onEnable2FAAuthenticationClickBtn(twoFactorAuth.enabledStatus.isEnabled)"
              data-testid="avios-linking-and-exchange-content-inactive-enable-2fa-button"
            ></fcom-button>
          </ng-container>
          <ng-container *ngSwitchCase="LinkAccountsFlowStep.LINK_ACCOUNTS">
            <h3 class="font-heading-5">
              {{ stepper.steps[stepper.activeStepIndex].title | finLocalization }}
            </h3>
            <p class="ms-medium-y">
              {{ 'LOYALTY.aviosLinkingAndExchange.linkYourAccounts.description' | finLocalization }}
            </p>
            <fcom-button
              *finLet="aviosLinkingStatus$ | async as aviosLinkingStatus"
              [text]="'LOYALTY.aviosLinkingAndExchange.linkYourAccounts.action' | finLocalization"
              [loading]="aviosLinkingStatus === AviosAccountLinkingStatus.LOADING"
              [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
              (clickBtn)="onLinkAccountsClickBtn()"
              data-testid="avios-linking-and-exchange-content-inactive-link-accounts-button"
            ></fcom-button>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>

<fcom-modal
  #modal
  [(open)]="isModalOpened"
  [title]="(modalFragments[modalOpened] | async)?.teaserTitle | finStripHtml"
  [buttons]="
    modalOpened === AviosLinkingAndExchangeModal.UnlinkAccount ? ModalButtons.CUSTOM : ModalButtons.CONTINUE_CANCEL
  "
  [fitToContent]="true"
  (confirm)="onModalConfirm()"
>
  <div class="pr-large">
    <div [innerHTML]="(modalFragments[modalOpened] | async)?.detailText | finSafe: 'html'"></div>

    <ng-container [ngSwitch]="modalOpened">
      <ng-container *ngSwitchCase="AviosLinkingAndExchangeModal.UnlinkAccount">
        <div class="flex rounded-large nordic-blue-25-bg ms-medium-t ps-medium-x ps-medium-y">
          <div class="flex flex-1 flex--middle">
            <div class="flex--nogrow">
              <fcom-icon
                class="baec-emblem"
                [category]="IconLibrary.CUSTOM"
                [name]="CustomIcon.BAEC_EMBLEM"
              ></fcom-icon>
            </div>
            <span class="flex-1 font-body-1 ms-xsmall-l ms-small-r">{{ AviosPartner.BAEC }}</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-container buttons>
    <fcom-button
      class="close-modal-btn mr-xsmall-r"
      [text]="'actions.cancel' | finLocalization"
      [disabled]="!modal.open || modal.forceRemainOpen"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      (clickBtn)="modal.onClose()"
    >
    </fcom-button>
    <fcom-button
      class="confirm-modal-btn"
      [text]="'LOYALTY.aviosLinkingAndExchange.unlinkAccount' | finLocalization"
      [disabled]="!modal.open || !modal.confirmEnabled || modal.forceRemainOpen"
      (clickBtn)="modal.onConfirm()"
    >
    </fcom-button>
  </ng-container>
</fcom-modal>
